/*
 * Montrelio — Positionnement des menus déroulants du header sous LEUR onglet.
 *
 *  A) Onglet overflow « Plus d'infos » : ouverture au clic/tap + panneau compact
 *     calé sous l'onglet (le thème l'ancre sinon au bord droit, via !important).
 *  B) Méga-menus catégories (Nos Montres, Montre Homme/Femme/Enfant, Accessoires) :
 *     le thème les rend pleine largeur, carte alignée à GAUCHE (sous le logo). On
 *     recale chaque carte sous son onglet, avec une sécurité anti-débordement à
 *     droite.
 *
 * Implémentation par DÉLÉGATION au niveau du document (indépendante du moment
 * d'hydratation). On positionne en !important pour battre les règles !important
 * du thème.
 */
(() => {
  const VIEWPORT_MARGIN = 16;
  const OPEN_SELECTOR = 'header-menu[data-overflow-expanded="true"]';

  const hostOf = (headerMenu) =>
    headerMenu && (headerMenu.querySelector('.overflow-menu') || headerMenu.querySelector('[ref="overflowMenu"]'));

  /* ============================ A) Overflow ============================ */

  const moreLiFromEvent = (e) => {
    const t = e.target;
    if (!(t instanceof Element) || !t.closest('header-menu, .overflow-menu')) return null;
    const path = typeof e.composedPath === 'function' ? e.composedPath() : [];
    for (const n of path) {
      if (n instanceof Element && n.matches && n.matches('[slot="more"]')) return n;
    }
    return null;
  };

  const positionOverflow = (moreLi) => {
    const headerMenu = moreLi.closest('header-menu');
    const host = hostOf(headerMenu);
    if (!host || !host.shadowRoot) return;
    const p = host.shadowRoot.querySelector('[part="overflow"]');
    if (!p || p.getBoundingClientRect().width === 0) return;
    const tab = moreLi.getBoundingClientRect();
    p.style.setProperty('right', 'auto', 'important');
    p.style.setProperty('left', '0px', 'important');
    const origin = p.getBoundingClientRect().left;
    p.style.setProperty('left', Math.round(tab.left - origin) + 'px', 'important');
  };

  const repositionOverflow = (moreLi) =>
    requestAnimationFrame(() => {
      positionOverflow(moreLi);
      requestAnimationFrame(() => positionOverflow(moreLi));
    });

  const closeAll = () => {
    document.querySelectorAll(OPEN_SELECTOR).forEach((hm) => {
      const ml = hm.querySelector('[slot="more"]');
      if (ml) {
        try {
          ml.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false }));
        } catch (e) {
          /* no-op */
        }
      }
    });
  };

  /* ======================= B) Méga-menus catégories =================== */

  const positionCategory = (li) => {
    const submenu = li.querySelector('.menu-list__submenu');
    if (!submenu) return;
    const card = submenu.querySelector('.mm-preview') || submenu.querySelector('.menu-list__submenu-inner');
    if (!card) return;
    // Reset pour mesurer la position naturelle, puis on décale sous l'onglet.
    card.style.setProperty('transform', 'none', 'important');
    const r = card.getBoundingClientRect();
    if (r.width === 0) return;
    const tab = li.getBoundingClientRect();
    const vw = document.documentElement.clientWidth;
    let left = tab.left;
    const maxLeft = vw - VIEWPORT_MARGIN - r.width; // anti-débordement à droite
    if (left > maxLeft) left = maxLeft;
    if (left < VIEWPORT_MARGIN) left = VIEWPORT_MARGIN;
    card.style.setProperty('transform', `translateX(${Math.round(left - r.left)}px)`, 'important');
  };

  const repositionCategory = (li) =>
    requestAnimationFrame(() => {
      positionCategory(li);
      requestAnimationFrame(() => positionCategory(li));
    });

  const categoryLiFromEvent = (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return null;
    const li = t.closest('.menu-list__list-item');
    if (!li || li.matches('[slot="more"]')) return null;
    if (!li.closest('header-menu') || !li.querySelector('.menu-list__submenu')) return null;
    return li;
  };

  /* ============================ Délégation ============================ */

  document.addEventListener('pointerover', (e) => {
    const t = e.target;
    if (!(t instanceof Element) || !t.closest('header-menu, .overflow-menu')) return;
    const moreLi = moreLiFromEvent(e);
    if (moreLi) {
      repositionOverflow(moreLi);
      return;
    }
    const li = categoryLiFromEvent(e);
    if (li) repositionCategory(li);
  });

  document.addEventListener(
    'click',
    (e) => {
      const moreLi = moreLiFromEvent(e);
      if (!moreLi) {
        const path = typeof e.composedPath === 'function' ? e.composedPath() : [];
        const insideOpenPanel = [...document.querySelectorAll(OPEN_SELECTOR)].some((hm) =>
          path.includes(hostOf(hm))
        );
        if (!insideOpenPanel) closeAll();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      const headerMenu = moreLi.closest('header-menu');
      const isOpen = headerMenu.dataset.overflowExpanded === 'true';
      try {
        moreLi.dispatchEvent(new PointerEvent(isOpen ? 'pointerleave' : 'pointerenter', { bubbles: false }));
      } catch (err) {
        /* no-op */
      }
      if (!isOpen) repositionOverflow(moreLi);
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(OPEN_SELECTOR).forEach((hm) => {
      const ml = hm.querySelector('[slot="more"]');
      if (ml) positionOverflow(ml);
    });
    document.querySelectorAll('header-menu .menu-list__list-item').forEach((li) => {
      if (li.matches('[slot="more"]')) return;
      if (li.querySelector('.menu-list__link[aria-expanded="true"]')) positionCategory(li);
    });
  });
})();
